import Http from "./Http";

export class ContentProposalService extends Http {
  /**
   * Get a list of users who can be proposed
   * @param {Object} params
   * @param {string} params.q
   * @param {number} params.limit
   * @param {number} params.offset
   */
  getRecipients(params) {
    return this.get("/content-proposals/recipients", { params });
  }

  /**
   * Create content proposal
   * @param {Object} body
   * @param {string} body.text
   * @param {number} body.contentType 1 - text, 2 - image, 3 - video, 4 - audio
   * @param {string} body.title
   * @param {string} body.description
   * @param {number} body.price
   */
  createProposal(body) {
    return this.post("/content-proposals", body);
  }

  /**
   * Update content proposal
   * @param {number} id
   * @param {Object} body
   * @param {string} body.title
   * @param {string} body.description
   */
  editProposal(id, body) {
    return this.put(`/content-proposals/${id}`, body);
  }

  /**
   * Get content proposal details
   * @param {number} id
   */
  getProposalDetails(id) {
    return this.get(`/content-proposals/${id}`);
  }
}

export default new ContentProposalService();
